import React from 'react';

export const ArrowSolidRight = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--arrow-solid-right';
  color = color || '#0076CC';

  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M9.34835 4.56385C10.0605 4.91151 10.1046 5.90987 9.42584 6.31894L1.5162 11.0862C0.849712 11.4879 6.02472e-08 11.0079 1.07503e-07 10.2297L6.3149e-07 1.601C6.76381e-07 0.861762 0.774405 0.378063 1.43871 0.702375L9.34835 4.56385Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowSolidRight;
